<template>
  <div>
    <iModal
      title="添加证件"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
          >
            <FormItem label="胸卡类型：" :required="true">
              <Select v-model="formInline.BadgeType" :disabled="true">
                <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="公司名称：" :required="true">
              <Input type="text" v-model="formInline.CompanyName" :disabled="true"></Input>
            </FormItem>
            <!-- <FormItem label="地址：">
              <Input type="text" v-model="formInline.Address" placeholder="请输入地址"></Input>
            </FormItem> -->

            <FormItem label="姓名：" prop="FirstName">
              <Input type="text" v-model="formInline.FirstName" placeholder="请输入姓名"></Input>
            </FormItem>
            <FormItem label="身份证号：" prop="IdCard" style="margin-bottom: 0">
              <Input type="text" v-model="formInline.IdCard" placeholder="请输入身份证号"></Input>
            </FormItem>
            <Checkbox v-model="single" style="margin: 24px 0 14px 100px" @on-change="changeCheck">港澳台，海外人员护照</Checkbox>
            <!-- <FormItem label="部门：">
              <Input type="text" v-model="formInline.Department" placeholder="请输入部门"></Input>
            </FormItem>
            <FormItem label="手机：">
              <Input type="text" v-model="formInline.Mob" placeholder="请输入手机"></Input>
            </FormItem> -->
            <FormItem label="电话：" prop="Tel">
              <Input type="text" v-model="formInline.Tel" placeholder="请输入电话"></Input>
            </FormItem>
            <!-- <FormItem label="传真：">
              <Input type="text" v-model="formInline.Fax" placeholder="请输入传真"></Input>
            </FormItem> -->
            <FormItem label="邮箱：" prop="Email">
              <Input type="text" v-model="formInline.Email" placeholder="请输入邮箱"></Input>
            </FormItem>
            <FormItem label="职务：" prop="JobTitle">
              <Input type="text" v-model="formInline.JobTitle" placeholder="请输入职务"></Input>
            </FormItem>
            <!-- <FormItem label="个人邮箱：">
              <Input type="text" v-model="formInline.PersonalEmail" placeholder="请输入个人邮箱"></Input>
            </FormItem> -->
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button style="width:90px;" type="primary" :loading="loading" @click="handleSubmit('formInline',0)">继续添加</Button>
        <Button style="width:90px;" type="primary" :loading="loading2" @click="handleSubmit('formInline',1)">完成</Button>
        <Button style="width:90px;" type="primary" @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import {  mapGetters, mapActions } from "vuex";

export default {
  name: "addCert",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    yesNumber:{
      type: Number,
    },
    NoNumber:{
      type: Number,
    }
  },
  data() {
    const viraIdcard = (rule, value, callback) => {
      if(value===''){
        callback(new Error('请输入身份证号'));
      }
      // else if (this.verification1 ==false&&this.check==true) {
      //   callback(new Error('请输入正确的海外证件'));
      // }
      else{
        callback()
      }
    };
    return {
      single:false,
      loading: false,
      loading2: false,
      showModal: false,
      verification1:false,//是否正则匹配通过
      check:false, //是否选择海外证件
      formInline: {
        BadgeType: "展商证",
        CompanyName: "",
        Address: "",
        FirstName: "",
        JobTitle: "",
        Department: "",
        Mob: "",
        Tel: "",
        Fax: "",
        Email: "",
        PersonalEmail: "",
        IdCard: ""
      },
      cityList: [
        {
          value: 'EnCard',
          label: '港澳台及海外'
        },
        {
          value: 'IdCard',
          label: '身份证'
        },
      ],
      model1: 'IdCard',
      ruleInline: {
        // 效验规则
        CompanyName:[
          {
            required: true,
            message: "请输入公司名",
            trigger: "blur"
          }
        ],
        FirstName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",

          }
        ], 
        IdCard: [
          {
            required: true,
            message: "",
            trigger: "blur",
            validator:viraIdcard,
          }
        ], 
        Tel: [
          {
            required: true,
            message: "请输入电话",
            trigger: "blur"
          }
        ],
        Email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur"
          }
        ],
        JobTitle: [
          {
            required: true,
            message: "请输入职务",
            trigger: "blur"
          }
        ],
        // Mob: validator.phone,
      },
      typeList: [
        {
          value: "展商证",
          label: "展商证",
        }
      ]
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (this.company) {
        this.formInline.CompanyName = this.company.name;
      }
      if (!val) this.$emit("close");
    },
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",  
      exhibition: "loginModule/getExhibition",
      joinInfo:'loginModule/getJoinInfo'
    }),
    exhibitonId() { return this.exhibition.id},
    header() { return this.$store.state.header},
  },
  methods: {
    ...mapActions({
      realAuth: "realAuth",
      
    }),

    async handleSubmit(name,e) {

      let form = this.formInline;
      let limitNumber=this.yesNumber+this.NoNumber
      let valid = await this.validForm(name);
      if (!valid) return;

      // 实名验证
      if(this.check==false){
        let info = await this.realAuth({
          idcard: this.formInline.IdCard,
          name: this.formInline.FirstName,
        });
        if (!info || !info.successed) {
          this.$Message.warning(info.msg,50);
          return;
        }
      }

      // if (this.joinInfo.boothArea<9&&limitNumber>2){
      //   this.$Message.error("申请证件数不能超过两张");
      //   return
      // }
      // if (this.joinInfo.boothArea>=9&&limitNumber>=Math.round(this.joinInfo.boothArea/9)*3&&Math.round(this.joinInfo.boothArea/9)*3!=0){
      //   this.$Message.error("申请证件数已达上限");
      //   return
      // }
      if (e === 0) {
        this.loading = true;
      } else {
        this.loading2 = true;
      }
      let body = {
        "ExhibitionId":this.exhibitonId,
        "JoinId":this.joinInfo.joinId,
        "DeExCardDown": {
          "JoinId":this.joinInfo.joinId,
          "BadgeType": "展商证",
          "CompanyName": form.CompanyName,
          "FirstName": form.FirstName,
          "JobTitle": form.JobTitle,
          "Tel": form.Tel,
          "Email": form.Email,
          "Idcard": form.IdCard,
        }
      }
      this.$http.post('/api/DeExCardDown',body,this.header)
        .then( res =>{
         if(res.status === 200 && res.data.successed){
           this.$Message.success("添加成功！");
           if (e === 0) {
            this.loading = false;
            this.$refs["formInline"].resetFields();
             // this.formInline.CompanyName = "";
            this.formInline.FirstName = "";
            this.formInline.JobTitle = "";
            this.formInline.Tel = "";
            this.formInline.Email = "";
            this.formInline.IdCard = "";
           } else {
            this.loading2 = false;
            this.$emit('addFinsh');
            this.cancel();
           }
         }else{
           if (e === 0) {
             this.loading = false;
           } else {
             this.loading2 = false;
           }
           this.$Message.error("添加失败，请重新尝试");
         }
        })
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      // this.formInline.CompanyName = "";
      this.formInline.FirstName = "";
      this.formInline.JobTitle = "";
      this.formInline.Tel = "";
      this.formInline.Email = "";
      this.formInline.IdCard = "";
      this.$emit("close");
    },
    changeCheck(e){
      this.check=e
    //  if (this.check==true){
    //    let reg=[/\d{9}/,/^\d{6,10}$/, /[a-zA-Z]{2}[0-9]{6}/, /[0-9]{2}[a-zA-Z]{2}[0-9]{5}/, /[a-zA-Z]{2}[0-9]{7}/, /[a-zA-Z]{3}[0-9]{6}/, /[a-zA-Z][a-zA-Z0-9]{7}[a-zA-Z]/,/[a-zA-Z]{1}[0-9]{8}/];
    //    this.verification1 =false
    //
    //    for(let i=0;i<reg.length;i++){
    //     if (reg[i].test(this.formInline.IdCard)){
    //       this.verification1=true
    //       break;
    //     }
    //    }
    //
    //  }
     }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

